import { useEffect, useState } from "react";


import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { preferenceService } from "../services/preferenceService";
import { setUserData } from "../features/user/userSlice";
import "./style.css";

const VerifyUpdatedEmail = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [, setIsError] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Clear localStorage and Redux state to logout user
    localStorage.clear();
    dispatch(setUserData({}));

    const token = searchParams.get("token");

    if (!token) {
      setMessage("Invalid verification link. No token provided.");
      setIsError(true);
      setIsLoading(false);
      return;
    }

    const verifyEmail = async () => {
      try {
        await preferenceService.verifyUpdatedEmail(token);
        setMessage("Work email has been successfully updated!");
        setIsSuccess(true);
      } catch (error) {
        setMessage(
          error.message || "Failed to verify email. Please try again."
        );
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, dispatch]);

  const handleLoginClick = () => {
    window.location.href = "/";
  };

  if (isLoading) {
    return (
      <div
        className="container-fluid d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Verifying your email...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="container-fluid d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="card shadow-lg"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <div className="card-body p-5 text-center">
          {isSuccess ? (
            <>
              <div className="mb-4">
                <i
                  className="bi bi-check-circle-fill text-success"
                  style={{ fontSize: "4rem" }}
                ></i>
              </div>
              <h2 className="card-title text-success mb-3">
                Email Updated Successfully!
              </h2>
              <p className="card-text text-muted mb-4">
                Please Signin with your new work email
              </p>
              <button
                className="btn btn-primary btn-lg px-4"
                onClick={handleLoginClick}
              >
                Go to Login
              </button>
            </>
          ) : (
            <>
              <div className="mb-4">
                <i
                  className="bi bi-x-circle-fill text-danger"
                  style={{ fontSize: "4rem" }}
                ></i>
              </div>
              <h2 className="card-title text-danger mb-3">
                Verification Failed
              </h2>
              {/* <p className="card-text text-muted mb-4">{message}</p> */}
              <button
                className="btn btn-outline-primary btn-lg px-4"
                onClick={handleLoginClick}
              >
                Go to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyUpdatedEmail;